/**
 * API Conversations Merge Plugin
 * Provides merge functionality for duplicate conversations in API inboxes
 */

import type { App } from 'vue';
import MergeConversationsButton from './components/MergeConversationsButton.vue';
import { inboxesActions } from './inboxesActions.js';

interface InstallContext {
  PluginSystem?: any;
  store?: any;
}

export function install(app: App, { PluginSystem, store }: InstallContext = {}) {
  // Register component globally
  app.component('MergeConversationsButton', MergeConversationsButton);

  // Register actions in the existing inboxes module
  if (store) {
    // Get the inboxes module
    const inboxesModule = store._modulesNamespaceMap['inboxes/'];
    
    if (inboxesModule) {
      // Add actions to the module's actions
      const moduleActions = inboxesModule._rawModule.actions || {};
      Object.assign(moduleActions, inboxesActions);
      inboxesModule._rawModule.actions = moduleActions;
      
      // Re-register the actions with proper context
      Object.keys(inboxesActions).forEach(actionName => {
        const fullActionName = `inboxes/${actionName}`;
        const action = (inboxesActions as any)[actionName];
        
        // Wrap the action - Vuex will call with (context, payload)
        const wrappedAction = function(context: any, payload: any) {
          console.log('[API-CONVERSATIONS-MERGE] Action called:', actionName, { context, payload });
          return action(context, payload);
        };
        
        if (!store._actions[fullActionName]) {
          store._actions[fullActionName] = [wrappedAction];
        } else {
          store._actions[fullActionName].push(wrappedAction);
        }
      });
      
      console.log('[API-CONVERSATIONS-MERGE] ✅ Vuex actions registered');
    } else {
      console.warn('[API-CONVERSATIONS-MERGE] ⚠️  Inboxes module not found');
    }
  } else {
    console.warn('[API-CONVERSATIONS-MERGE] ⚠️  Store not available, actions not registered');
  }
}

export default {
  install,
};
